import { get, post, del, patch } from '@/shared/utils/api-utils'
import {
  IndividualUserInfo,
  InsertUser,
  User,
  UserPreferences,
  UsersTableData,
} from '@depanneo/types'

/**
 * `CreateUserDto`: a user row plus the ids of the sites it is linked to. The
 * org is optional — the server falls back to the caller's own.
 */
export type CreateUserPayload = Omit<InsertUser, 'organizationId'> & {
  organizationId?: string
  sites?: string[]
}

const createUser = async (data: CreateUserPayload) => {
  return await post<User, CreateUserPayload>('/users', data)
}

const findAllUsers = async () => {
  return await get<UsersTableData[]>('/users')
}

const findPlatformTeamUsers = async () => {
  return await get<UsersTableData[]>('/users/platform-team')
}

const findUser = async (id: string) => {
  return await get<IndividualUserInfo>(`/users/${id}`)
}
const updateUser = async (id: string, data: FormData) => {
  return await patch<User, FormData>(`/users/${id}`, data)
}

const changePassword = async (
  id: string,
  data: { currentPassword: string; newPassword: string }
) => {
  return await patch<User, { currentPassword: string; newPassword: string }>(
    `/users/${id}/password`,
    data
  )
}

const removeUser = async (id: string) => {
  return await del<User>(`/users/${id}`)
}

const bulkDeleteUsers = async (ids: string[]) => {
  return await post<{ deleted: number; total: number }, { ids: string[] }>(
    '/users/bulk-delete',
    { ids }
  )
}

const resendInvitation = async (id: string) => {
  return await post<User, undefined>(
    `/users/${id}/resend-invitation`,
    undefined
  )
}

const updateUserPreferences = async (id: string, data: UserPreferences) => {
  return await patch<User, UserPreferences>(`/users/${id}/preferences`, data)
}

export {
  createUser,
  findAllUsers,
  findPlatformTeamUsers,
  findUser,
  removeUser,
  bulkDeleteUsers,
  updateUser,
  changePassword,
  resendInvitation,
  updateUserPreferences,
}
